import FIELDS from '../../../../library/acesso-dados-fields';
import appYup from '../../../../library/validation/validation';

const {
  EMAIL,
  CORRENSPONDENCIA,
  OUTRAS_SOLICITACOES: { VALOR_ELIMINAR, VALOR_BLOQUEAR },
} = FIELDS;

const formOutrasSolicitacoesSchema = appYup.object().shape(
  {
    [EMAIL]: appYup.string().when(CORRENSPONDENCIA, ([val]) =>
        !val
            ? appYup.string().required().email()
            : appYup.string().email(),
        ),
    [CORRENSPONDENCIA]: appYup.string().when(EMAIL, ([val]) =>
        !val
            ? appYup.string().required().max(400)
            : appYup.string().max(400),
        ),
    [VALOR_ELIMINAR]: appYup.string().max(400),
    [VALOR_BLOQUEAR]: appYup.string().max(400),
  },
  [EMAIL, CORRENSPONDENCIA],
);

export default formOutrasSolicitacoesSchema;
